import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';

import { formatNumber } from 'utils/helper';

import './UsedGlobalsPage.scss';

const formatGlobalValue = value => {
  const numberValue = Number(value);

  if (Number.isFinite(numberValue)) {
    return formatNumber(numberValue);
  }

  return value || '';
};

const UsedGlobalsPage = ({
  globals,
  printLayoutHeader,
  printLayoutFooter,
  classNamePrefix,
}) => {
  const layoutClassName = `${classNamePrefix || ''}print-layout`;

  if (!globals?.length) {
    return null;
  }

  return (
    <div className={`${layoutClassName} used-globals-page-shell`}>
      {printLayoutHeader}
      <div className="used-globals-page">
        <div className="used-globals-page__title">Used Globals</div>
        <Table
          className="used-globals-page__table budget-details-table"
          bordered
          striped
        >
          <thead>
            <tr>
              <th>Abbrev.</th>
              <th>Name</th>
              <th>Calculation</th>
              <th>Units</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {globals.map(globalItem => (
              <tr key={globalItem.id || globalItem.abbreviation}>
                <td className="used-globals-page__abbreviation">
                  {globalItem.abbreviation}
                </td>
                <td>{globalItem.name}</td>
                <td>{globalItem.calculation}</td>
                <td>{globalItem.units}</td>
                <td className="used-globals-page__value">
                  {formatGlobalValue(globalItem.value)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <div style={{ flexGrow: 1 }} />
      {printLayoutFooter}
    </div>
  );
};

UsedGlobalsPage.defaultProps = {
  globals: [],
  classNamePrefix: '',
};

UsedGlobalsPage.propTypes = {
  globals: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      abbreviation: PropTypes.string,
      name: PropTypes.string,
      calculation: PropTypes.string,
      units: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ),
  printLayoutHeader: PropTypes.node.isRequired,
  printLayoutFooter: PropTypes.node.isRequired,
  classNamePrefix: PropTypes.string,
};

export default UsedGlobalsPage;
